/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */ export const authenticatedUserApi = {
  AUTHENTICATE_USER: "/auth/authenticate",
};

export const countryAPI = {
  GET_COUNTRIES: "/countries",
  GET_COUNTRIES_PREFIX: "/public/countries/prefixes",
};

export const studyOrderAPI = {
  GET_STUDY_ORDER: "/studies",
  GET_STUDY_ORDER_DETAIL: (id: string) => `/studies/${id}`,
  GET_STUDY_ORDER_DIAGNOSTIC_REPORT: (id: string) =>
    `/studies/${id}/diagnosticReport`,
  GET_STUDY_ORDER_DIAGNOSTIC_REPORT_CONTENT: (id: string, contentId: string) =>
    `/studies/${id}/diagnosticReport/content/${contentId}`,
  GET_STUDY_ORDER_DIAGNOSTIC_REPORT_PDF: (id: string, contentId: string) =>
    `/studies/${id}/diagnosticReport/content/${contentId}/pdf`,
};

export const seriesAPI = {
  GET_SERIES: (studyId: string) => `/studies/${studyId}/series`,
  GET_SERIES_THUMBNAIL: (studyId: string, seriesId: string) =>
    `/studies/${studyId}/series/${seriesId}/thumbnail`,
};

export const instanceAPI = {
  GET_INSTANCE: (studyId: string, seriesId: string) =>
    `/studies/${studyId}/series/${seriesId}/instances`,
  DOWNLOAD_SERIES_AS_ZIP: (studyId: string, seriesId: string): string =>
    `/studies/${studyId}/series/${seriesId}/download/zip`,
  DOWNLOAD_SERIES_AS_VIDEO: (studyId: string, seriesId: string): string =>
    `/studies/${studyId}/series/${seriesId}/download/video`,
  DOWNLOAD_FRAMES_AS_ZIP: (
    studyId: string,
    seriesId: string,
    instanceId: string
  ) =>
    `/studies/${studyId}/series/${seriesId}/instances/${instanceId}/frames/render/zip`,
  DOWNLOAD_FRAMES_AS_VIDEO: (
    studyId: string,
    seriesId: string,
    instanceId: string
  ) =>
    `/studies/${studyId}/series/${seriesId}/instances/${instanceId}/frames/render/video`,
  DOWNLOAD_INSTANCE_JPEG: (
    studyId: string,
    seriesId: string,
    instanceId: string,
    frame?: number
  ) =>
    `/studies/${studyId}/series/${seriesId}/instances/${instanceId}/render?quality=100&download=true${
      frame ? `&frame=${frame}` : ""
    }`,
  DOWNLOAD_INSTANCE_DICOM: (
    studyId: string,
    seriesId: string,
    instanceId: string
  ) =>
    `/studies/${studyId}/series/${seriesId}/instances/${instanceId}/download/dicom`,
  GET_RENDER_INSTANCE: (
    studyId: string,
    seriesId: string,
    instanceId: string
  ) => `/studies/${studyId}/series/${seriesId}/instances/${instanceId}/render`,
};

export const EulaAPI = {
  GET_EULA: "/endUserLicenseAgreements/current",
  GET_EULA_LATEST: "/endUserLicenseAgreements/latest",
  ACCEPT_EULA: "/endUserLicenseAgreements/current/accept",
};
